import styled from 'styled-components';
import { EntityIcon } from 'components/Global/EntityItem/styled';

export const ChecklistFilterContainer = styled.div`
  border-radius: 4px;
  line-height: 32px;
  padding: ${({ theme }) => `${theme.padding.small} 0`};
`;

export const ChecklistScrollContainer = styled.div`
  height: 200px;
`;

export const ChecklistTick = styled.div`
  background: ${({ theme, selected }) => selected ? theme.colors.palette[7] : '#F3F4F5'};
  border-radius: 100%;
  width: 6px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 13px;
`;

export const ChecklistItemContainer = styled.div`
  padding-left: ${({ theme }) => theme.padding.medium};
  line-height: 36px;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;


  ${EntityIcon} {
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.1);
    position: relative;
    top: 8px;
    left: -8px;
  }

  &:hover {
    ${ChecklistTick} {
      background: ${({ theme, selected }) => selected ? theme.colors.palette[7] : '#CBCED6'};
    }
  }
`;

export const ChecklistItemName = styled.span`
  letter-spacing: 0.02em;
  color: #343434;
  font-size: 14px;
`;
